import { useRouter } from "@services/routing-services";
import { useIntl } from "@services/i18n/i18nservice";

let imageViewerRouteName: string | undefined;

export function configureDocumentViewer(routeName: string): void {
  imageViewerRouteName = routeName;
}

const imageExtensions = new Set([
  "jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "ico", "webp", "svg", "avif", "heic", "heif",
]);

export function isImageDocument(fileName: string): boolean {
  const name = fileName.split(/[?#]/)[0];
  return imageExtensions.has(name.slice(name.lastIndexOf(".") + 1).toLowerCase());
}

export function openDocumentInNewTab(url: string, fileName = "", rotation = 0): void {
  if (!imageViewerRouteName || (!isImageDocument(fileName) && !isImageDocument(url))) {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }

  const name = (fileName || url).split(/[?#]/)[0].split("/").pop() ?? "";
  const hash = new URLSearchParams({ url, fileName: name, rotation: String(rotation) });
  const route = useIntl().i18Route({ name: imageViewerRouteName, hash: `#${hash}` });
  window.open(useRouter().resolve(route).href, "_blank", "noopener,noreferrer");
}
